<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Lançar estoque</h2>
    <span class="modal-subtitle">Confirma a baixa das matérias-primas e a entrada do produto fabricado no
      estoque.</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" (click)="cancelar()" [disabled]="isSalvando">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
    <mat-label>Localização de entrada (produto fabricado)</mat-label>
    <mat-select [(ngModel)]="idLocalizacaoEstoqueEntrada">
      @for (local of localizacoes; track local.id) {
      <mat-option [value]="local.id">{{ local.descricao }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <!-- ── Baixa de matéria-prima ───────────────────────────────────────────── -->
  <h3 class="secao-caption">Baixa de matéria-prima</h3>

  <div class="table-responsive baixa-desktop-view">
    <table mat-table [dataSource]="linhas" class="mat-elevation-z0 tabela-baixa">

      <ng-container matColumnDef="item">
        <th mat-header-cell *matHeaderCellDef>Item</th>
        <td mat-cell *matCellDef="let linha">
          <strong>{{ linha.item.nomeProduto }}</strong>
          <span class="item-sku">{{ linha.item.codigoSku }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="movimento">
        <th mat-header-cell *matHeaderCellDef>Movimento</th>
        <td mat-cell *matCellDef="let linha" class="valor-negativo">
          −{{ linha.item.quantidadeTotal | abnt:'quantidade':(linha.item.isUnidadeMedidaFracionada ? undefined : 0) }} {{
          linha.item.unidade }}
        </td>
      </ng-container>

      <ng-container matColumnDef="estoqueAtual">
        <th mat-header-cell *matHeaderCellDef>Estoque atual</th>
        <td mat-cell *matCellDef="let linha">
          {{ linha.item.saldoAtual === null ? '--' : (linha.item.saldoAtual | abnt:'quantidade':(linha.item.isUnidadeMedidaFracionada
          ? undefined : 0)) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="apos">
        <th mat-header-cell *matHeaderCellDef>Após</th>
        <td mat-cell *matCellDef="let linha"
          [class.saldo-negativo]="saldoApos(linha.item) !== null && saldoApos(linha.item)! < 0">
          <strong>{{ saldoApos(linha.item) === null ? '--' : (saldoApos(linha.item) |
            abnt:'quantidade':(linha.item.isUnidadeMedidaFracionada ? undefined : 0)) }}</strong>
        </td>
      </ng-container>

      <ng-container matColumnDef="localizacaoSaida">
        <th mat-header-cell *matHeaderCellDef>Localização de saída</th>
        <td mat-cell *matCellDef="let linha">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
            <mat-select [(ngModel)]="linha.idLocalizacaoEstoque" (ngModelChange)="onLocalizacaoInsumoChange(linha)">
              @for (local of localizacoes; track local.id) {
              <mat-option [value]="local.id">{{ local.descricao }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="rastreabilidade">
        <td mat-cell *matCellDef="let linha" [attr.colspan]="displayedColumns.length" class="rastreabilidade-cell">
          @if (linha.item.isControlaLotes) {
          <app-estoque-lote-serie-inline tipo="lote" modo="selecionar" [contexto]="linha.item.nomeProduto"
            [idProduto]="linha.item.idProduto" [idLocalizacaoEstoque]="linha.idLocalizacaoEstoque ?? undefined"
            [quantidadeAlvo]="linha.item.quantidadeTotal" [isFracionada]="linha.item.isUnidadeMedidaFracionada"
            [itens]="linha.itensRastreabilidade" (itensChange)="onItensRastreabilidadeChange(linha, $event)"
            (completoChange)="onRastreabilidadeCompletaChange(linha, $event)">
          </app-estoque-lote-serie-inline>
          }
          @if (linha.item.isControlaSeries) {
          <app-estoque-lote-serie-inline tipo="serie" modo="selecionar" [contexto]="linha.item.nomeProduto"
            [idProduto]="linha.item.idProduto" [idLocalizacaoEstoque]="linha.idLocalizacaoEstoque ?? undefined"
            [quantidadeAlvo]="linha.item.quantidadeTotal" [isFracionada]="linha.item.isUnidadeMedidaFracionada"
            [itens]="linha.itensRastreabilidade" (itensChange)="onItensRastreabilidadeChange(linha, $event)"
            (completoChange)="onRastreabilidadeCompletaChange(linha, $event)">
          </app-estoque-lote-serie-inline>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: ['rastreabilidade']; when: temRastreabilidade"
        class="rastreabilidade-row"></tr>
    </table>
  </div>

  <div class="baixa-mobile-view">
    @for (linha of linhas; track linha.item.idOrdemProducaoItem) {
    <div class="item-card">
      <div class="item-card__header">
        <div>
          <strong>{{ linha.item.nomeProduto }}</strong>
          <span class="item-card__sku">{{ linha.item.codigoSku }}</span>
        </div>
        <span class="valor-negativo">
          −{{ linha.item.quantidadeTotal | abnt:'quantidade':(linha.item.isUnidadeMedidaFracionada ? undefined : 0) }} {{
          linha.item.unidade }}
        </span>
      </div>
      <div class="item-card__body">
        <div class="item-card__grid">
          <div>
            <span class="item-card__label">Estoque atual</span>
            <span>{{ linha.item.saldoAtual === null ? '--' : (linha.item.saldoAtual |
              abnt:'quantidade':(linha.item.isUnidadeMedidaFracionada ? undefined : 0)) }}</span>
          </div>
          <div>
            <span class="item-card__label">Após</span>
            <span [class.saldo-negativo]="saldoApos(linha.item) !== null && saldoApos(linha.item)! < 0">
              {{ saldoApos(linha.item) === null ? '--' : (saldoApos(linha.item) |
              abnt:'quantidade':(linha.item.isUnidadeMedidaFracionada ? undefined : 0)) }}
            </span>
          </div>
        </div>

        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mt-2">
          <mat-label>Localização de saída</mat-label>
          <mat-select [(ngModel)]="linha.idLocalizacaoEstoque" (ngModelChange)="onLocalizacaoInsumoChange(linha)">
            @for (local of localizacoes; track local.id) {
            <mat-option [value]="local.id">{{ local.descricao }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        @if (linha.item.isControlaLotes) {
        <app-estoque-lote-serie-inline tipo="lote" modo="selecionar" [contexto]="linha.item.nomeProduto"
          [idProduto]="linha.item.idProduto" [idLocalizacaoEstoque]="linha.idLocalizacaoEstoque ?? undefined"
          [quantidadeAlvo]="linha.item.quantidadeTotal" [isFracionada]="linha.item.isUnidadeMedidaFracionada"
          [itens]="linha.itensRastreabilidade" (itensChange)="onItensRastreabilidadeChange(linha, $event)"
          (completoChange)="onRastreabilidadeCompletaChange(linha, $event)">
        </app-estoque-lote-serie-inline>
        }
        @if (linha.item.isControlaSeries) {
        <app-estoque-lote-serie-inline tipo="serie" modo="selecionar" [contexto]="linha.item.nomeProduto"
          [idProduto]="linha.item.idProduto" [idLocalizacaoEstoque]="linha.idLocalizacaoEstoque ?? undefined"
          [quantidadeAlvo]="linha.item.quantidadeTotal" [isFracionada]="linha.item.isUnidadeMedidaFracionada"
          [itens]="linha.itensRastreabilidade" (itensChange)="onItensRastreabilidadeChange(linha, $event)"
          (completoChange)="onRastreabilidadeCompletaChange(linha, $event)">
        </app-estoque-lote-serie-inline>
        }
      </div>
    </div>
    }
  </div>

  <!-- ── Entrada do produto fabricado ────────────────────────────────────── -->
  <h3 class="secao-caption">Entrada do produto fabricado</h3>

  <app-alert-card type="success">
    <div class="entrada-resumo">
      <div>
        <strong>{{ data.ordem.nomeProduto }}</strong>
        <span class="item-card__sku">{{ data.ordem.codigoSku }}</span>
      </div>
      <div class="entrada-resumo__valores">
        <span class="valor-positivo">+{{ quantidadeEntrada | abnt:'quantidade':(data.ordem.isUnidadeMedidaFracionada ? undefined : 0)
          }} {{ data.ordem.unidade }}</span>
        <span class="entrada-resumo__saldo">
          <span>{{ data.ordem.quantidade | abnt:'quantidade':(data.ordem.isUnidadeMedidaFracionada ? undefined : 0) }} {{
            data.ordem.unidade }}</span>
          <span>{{ (data.ordem.quantidade + quantidadeEntrada) | abnt:'quantidade':(data.ordem.isUnidadeMedidaFracionada ? undefined
            : 0) }} {{ data.ordem.unidade }}</span>
        </span>
      </div>
    </div>
  </app-alert-card>

  <mat-form-field appearance="outline" class="w-100 mt-1" subscriptSizing="dynamic">
    <mat-label>Quantidade a dar entrada ({{ data.ordem.unidade }})</mat-label>
    <input matInput [(ngModel)]="quantidadeEntrada" [currencyMask]="quantidadeMask" />
  </mat-form-field>

  @if (houveAjuste) {
  <div class="ajuste-aviso" [class.ajuste-positivo]="delta > 0" [class.ajuste-negativo]="delta < 0">
    <mat-icon class="material-symbols-outlined">info</mat-icon>
    <span>Ajuste de {{ delta > 0 ? '+' : '' }}{{ delta | abnt:'quantidade':(data.ordem.isUnidadeMedidaFracionada ? undefined : 0) }}
      {{ data.ordem.unidade }} sobre a OP</span>
  </div>
  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
    <mat-label>Justificativa do ajuste</mat-label>
    <textarea matInput rows="2" [(ngModel)]="justificativaAjusteEntrada"></textarea>
  </mat-form-field>
  }

  @if (data.ordem.isControlaLotes) {
  <div class="rastreabilidade-hint">
    <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
    <span>Produto com controle de lote — informe os dados do lote.</span>
  </div>
  <div class="row g-3">
    <div class="col-12 col-sm-4">
      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
        <mat-label>Código do lote*</mat-label>
        <input matInput [(ngModel)]="codigoLoteEntrada" placeholder="Ex: L-01" />
      </mat-form-field>
    </div>
    <div class="col-12 col-sm-4">
      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
        <mat-label>Data de fabricação*</mat-label>
        <input matInput [matDatepicker]="pickerFabEntrada" [(ngModel)]="dataFabricacaoLoteEntrada"
          placeholder="DD/MM/AAAA" />
        <mat-datepicker-toggle matIconSuffix [for]="pickerFabEntrada"></mat-datepicker-toggle>
        <mat-datepicker #pickerFabEntrada></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-12 col-sm-4">
      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
        <mat-label>Data de validade*</mat-label>
        <input matInput [matDatepicker]="pickerValEntrada" [(ngModel)]="dataValidadeLoteEntrada"
          placeholder="DD/MM/AAAA" />
        <mat-datepicker-toggle matIconSuffix [for]="pickerValEntrada"></mat-datepicker-toggle>
        <mat-datepicker #pickerValEntrada></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
  }

  @if (data.ordem.isControlaSeries) {
  <div class="rastreabilidade-hint">
    <mat-icon class="material-symbols-outlined">qr_code_2</mat-icon>
    <span>Produto com controle de série — informe os códigos de série.</span>
  </div>
  <div class="serie-toolbar">
    <button mat-stroked-button type="button" class="btn-secondary" (click)="gerarSeriesAutomaticamente()">
      Gerar automaticamente
    </button>
  </div>
  <app-estoque-lote-serie-inline tipo="serie" modo="criar" contexto="Entrada do produto fabricado"
    [quantidadeAlvo]="quantidadeEntrada" [isFracionada]="data.ordem.isUnidadeMedidaFracionada" [itens]="itensEntradaSerie"
    [(aberto)]="abertoEntrada" (itensChange)="onItensEntradaSerieChange($event)"
    (completoChange)="serieEntradaCompleta = $event">
  </app-estoque-lote-serie-inline>
  }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button class="btn-secondary" (click)="cancelar()" [disabled]="isSalvando">Cancelar</button>
  <button mat-flat-button class="btn-primary" [disabled]="!podeConfirmar" (click)="confirmar()">Confirmar</button>
</mat-dialog-actions>